import React, {useContext, useEffect, useState} from 'react'
import Table from 'react-bootstrap/Table';
import ChangeSchedulesForm from "./ChangeSchedulesForms";

/* eslint-disable react/prop-types */
const ChangeSchedulesModal = ({ schedules, onSchedulesChange }) => {

    return (
        <div>
            <h2>Horaires du magasin</h2>
            <p>Pour mieux vous servir, merci d'indiquer vos horaires d'ouverture et de fermeture</p>
            <ChangeSchedulesForm schedules={schedules} onSchedulesChange={onSchedulesChange} />
            <p className='font-weight-bold mt-4'>
                Aide:
            </p>
            <p>
                Si vous souhaitez déclarer une journée continue, sélectionnez un horaire identique en fin de matinées et en début d'après midi.
            </p>
            <p>Exemple d'une journée en continue de 10h à 17h :</p>
            <Table>
                <thead>
                    <tr>
                        <th>Début de matinée</th>
                        <th>Fin de matinée</th>
                        <th>Début d'après midi</th>
                        <th>Fin d'après midi</th>
                    </tr>
                </thead>
                <tbody>
                <tr>
                    <td>10:00</td>
                    <td>12:00</td>
                        <td>12:00</td>
                        <td>17:00</td>
                    </tr>
                </tbody>
            </Table>
        </div>
    )
}

export default ChangeSchedulesModal
